// src/components/legal/LegalDocumentDialog.tsx
import React from "react";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { alpha } from "@mui/material/styles";
import { LegalDocType, LegalDocumentContent } from "../../legal/legalDocuments";

const BORDER = "rgba(120,140,180,.18)";
const TEXT_SUB = "#9fb4d8";
const CARD_BG = "#0b1522";

interface LegalDocumentDialogProps {
  open: boolean;
  onClose: () => void;
  type: LegalDocType;
}

export default function LegalDocumentDialog({
  open,
  onClose,
  type,
}: LegalDocumentDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: 18,
          border: `1px solid ${BORDER}`,
          background: CARD_BG,
          boxShadow: "0 18px 40px rgba(8,20,40,.55)",
        },
      }}
      BackdropProps={{ sx: { backgroundColor: "rgba(0,0,0,.65)" } }}
    >
      <DialogContent sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
          <Box />
          <IconButton onClick={onClose} sx={{ color: TEXT_SUB }}>
            <CloseRoundedIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            maxHeight: "70vh",
            overflow: "auto",
            pr: 0.5,
            "&::-webkit-scrollbar": { width: 10 },
            "&::-webkit-scrollbar-thumb": {
              background: alpha("#7fb0ff", 0.25),
              borderRadius: 10,
            },
            "&::-webkit-scrollbar-track": {
              background: alpha("#0e1a2b", 0.35),
              borderRadius: 10,
            },
          }}
        >
          <LegalDocumentContent type={type} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
